import { BaseballGameDataModel } from "../../../Models";
import { getSwappedValue } from "../../GetSwappedValue";
import { DisplayedBaseballInnings, BaseballCurrentBattingTeam } from "../../../Constants";
import { getPartScore } from "../../../Helpers";
import { LiveMasterEventLegacy } from "sb-resp-lib";

function parseToBaseballscoreboardGameDataModel(event: LiveMasterEventLegacy): BaseballGameDataModel {
    let homeInnings:string[] = [], awayInnings:string[] = [];
    let result = {} as BaseballGameDataModel;

    if (event && event.BaseballScoreBoardInfo) {

        event.BaseballScoreBoardInfo && event.BaseballScoreBoardInfo.innings.forEach(function(inning,index){
            event.BaseballScoreBoardInfo && homeInnings.push(getPartScore(event.BaseballScoreBoardInfo.currentInning, index, inning.homeTeamScore));
            event.BaseballScoreBoardInfo && awayInnings.push(getPartScore(event.BaseballScoreBoardInfo.currentInning, index, inning.awayTeamScore));
        });

        result = new BaseballGameDataModel({
            eventId: parseInt(event.ID),
            participant1Name: getSwappedValue(event.IsTeamSwapEnabled, event.Team1Name, event.Team2Name),
            participant2Name: getSwappedValue(event.IsTeamSwapEnabled, event.Team2Name, event.Team1Name),
            displayedInnings: DisplayedBaseballInnings,
            homeInnings: getSwappedValue(event.IsTeamSwapEnabled, homeInnings, awayInnings),
            awayInnings: getSwappedValue(event.IsTeamSwapEnabled, awayInnings, homeInnings),
            homeTotalInnings: getSwappedValue(event.IsTeamSwapEnabled, parseInt(event.Score1), parseInt(event.Score2)),
            awayTotalInnings: getSwappedValue(event.IsTeamSwapEnabled, parseInt(event.Score2), parseInt(event.Score1)),
            homeHits: getSwappedValue(event.IsTeamSwapEnabled, event.BaseballScoreBoardInfo.homeHits, event.BaseballScoreBoardInfo.awayHits),
            awayHits: getSwappedValue(event.IsTeamSwapEnabled, event.BaseballScoreBoardInfo.awayHits, event.BaseballScoreBoardInfo.homeHits),
            currentInning: event.BaseballScoreBoardInfo.currentInning,
            balls: event.BaseballScoreBoardInfo.balls,
            outs: event.BaseballScoreBoardInfo.outs,
            strikes: event.BaseballScoreBoardInfo.strikes,
            base: event.BaseballScoreBoardInfo.base,
            currentTeamServing: event.IsTeamSwapEnabled
                                    ? event.BaseballScoreBoardInfo.currentTeamServing === BaseballCurrentBattingTeam.Home
                                        ? BaseballCurrentBattingTeam.Away
                                        : BaseballCurrentBattingTeam.Home
                                    : event.BaseballScoreBoardInfo.currentTeamServing
        });
    }

    return result;
}

export { parseToBaseballscoreboardGameDataModel }
export { parseToBaseballscoreboardGameDataModel as BaseballScoreboard };